import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { Competition } from '@ilteducation/competition-referee-types';

type Props = {
  title: string;
  item?: Competition;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  props: {
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  item?: Competition;
}



const startOfToday = new Date();
startOfToday.setHours(0, 0, 0, 0);

const inTreeMonths = new Date();
inTreeMonths.setDate(inTreeMonths.getDate() + 90);
inTreeMonths.setHours(23, 59, 59, 999);

const createCompetitionItem = props.item || {
  name: '',
  realm: '',
  startAt: startOfToday.toISOString(),
  endAt: inTreeMonths.toISOString(),
};

return { __sfc: true,props, startOfToday, inTreeMonths, createCompetitionItem }
}

})